
/*
    Marquee
*/
const initMarqueeSections = () => {
  document.querySelectorAll('.marquee').forEach(section => {
    const list = section.querySelector('ul')
    const marqueeWidth = list.scrollWidth
    const marqueeLength = list.querySelectorAll('li').length

    list.insertAdjacentHTML('beforeEnd', list.innerHTML)
    list.insertAdjacentHTML('beforeEnd', list.innerHTML)

    list.querySelectorAll('li').forEach((item, index) => {
      if (index >= marqueeLength) {
        item.setAttribute('aria-hidden', 'true')
      }
    })

    let translateX = `-${marqueeWidth}`

    if (document.documentElement.getAttribute('dir') === 'rtl') {
      translateX = `${marqueeWidth}`
    }

    let style = `
            <style>
                #marquee-${list.dataset.sectionId} ul {
                    animation-name: marquee-animation-${list.dataset.sectionId};
                    animation-duration: ${list.dataset.animationDuration}s;
                }
                @keyframes marquee-animation-${list.dataset.sectionId} {
                    to { transform: translateX(${translateX}px); }
                }
            </style>
        `
    if (list.dataset.marqueeDirection === 'right') {
      style += `
                <style>
                    @keyframes marquee-animation-${list.dataset.sectionId} {
                        from { transform: translateX(${translateX}px); }    
                        to { transform: 0); }    
                    }
                </style>
            `
    }

    list.insertAdjacentHTML('beforeBegin', style)
  })
}
initMarqueeSections()

document.addEventListener('shopify:section:load', (e) => {
  if (e.target.querySelector('.marquee')) {
    initMarqueeSections()
  }
})